module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Bold.ef576a3.woff2";